module.exports = __webpack_public_path__ + "static/media/15.91a698c6.png";